import type { TerminalBootstrap } from "./models";

/** A refreshed identity never authorizes replaying a previous session's mutation. */
export function classifyTerminalSessionRecovery(
  previous: { terminalCode: string; operatorId: string; lineId: string },
  next: Pick<TerminalBootstrap, "terminal" | "session">,
): "same-owner" | "changed-owner" | "unavailable" {
  if (!next.session || next.session.status !== "ACTIVE") return "unavailable";
  return next.terminal.terminalCode === previous.terminalCode &&
    next.terminal.lineId === previous.lineId && next.session.operatorId === previous.operatorId
    ? "same-owner" : "changed-owner";
}
